module.exports = __webpack_public_path__ + "img/医生01.ea9580ef.png";